import { render, staticRenderFns } from "./mostProducts.vue?vue&type=template&id=52a51345&scoped=true&"
import script from "./mostProducts.vue?vue&type=script&lang=js&"
export * from "./mostProducts.vue?vue&type=script&lang=js&"
import style0 from "./mostProducts.vue?vue&type=style&index=0&id=52a51345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a51345",
  null
  
)

export default component.exports